import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';

var dotsThemeWeb = {
  activeColor: 'primary',
  inactiveColor: colors.fogGrey,
  size: {
    active: 12,
    inactive: 8
  }
};
var dotsDarkThemeWeb = _extends({}, dotsThemeWeb, {
  inactiveColor: colors.emperorGrey
});
var dotsThemeNative = {
  activeColor: 'primary',
  inactiveColor: colors.fogGrey,
  size: {
    active: 12,
    inactive: 8
  }
};
var dotsDarkThemeNative = _extends({}, dotsThemeNative, {
  activeColor: 'primary',
  inactiveColor: colors.inkGrey
});

export { dotsDarkThemeNative, dotsDarkThemeWeb, dotsThemeNative, dotsThemeWeb };
